import * as React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { queryClient } from '@src/services/common';
import * as queries from '@src/services/queries';
import DimensionForm from '@src/features/DimensionFormContainer';
import SettingsContainer from '@shared/components/SettingsContainer';
import { useEditingContext } from './context';

const Dimensions = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { search } = useLocation();
  const { onDispose, onUpdate, cachedValues } = useEditingContext();

  const handleDispose = React.useCallback(() => {
    onDispose?.();
    void navigate(
      {
        pathname: '..',
        search,
      },
      { replace: true },
    );
  }, [onDispose, navigate, search]);

  const handleSave = React.useCallback<GetProp<typeof DimensionForm, 'onSave'>>(() => {
    void queryClient.invalidateQueries({
      queryKey: [queries.QUERY_KEY_DIMENSIONS],
    });
    handleDispose();
  }, [handleDispose]);

  return (
    <SettingsContainer header="Edit Dimension">
      <DimensionForm
        id={id}
        initialValue={cachedValues}
        onChange={onUpdate}
        onCancel={handleDispose}
        onSave={handleSave}
      />
    </SettingsContainer>
  );
};

export const DimensionsEditing = React.memo(Dimensions);
